import { render, staticRenderFns } from "./Waterkotte_EcoPack_2d02.vue?vue&type=template&id=54f3570f&"
import script from "./Waterkotte_EcoPack_2d02.vue?vue&type=script&lang=js&"
export * from "./Waterkotte_EcoPack_2d02.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports